import React from "react";


const Searchbox= ({searchfield,searchchange})=>{
    return (
        <div className="pa2">
            <input  className="pa3 ba b--green bg-lightest-blue"
            type="text" placeholder="Search your robots"
            onChange={searchchange}>
            
            </input>

        </div>
    )
}

export default Searchbox;